import { Variants } from 'common';

const config = {
  [Variants.DUCKPIN]: {
    reserve: 'Book a Lane',
    simulators: 'Lanes',
    reserveDescription1: 'Book by the hour for up to 6 bowlers per lane.',
    reserveDescription2: 'Let the good times roll! No bowling shoes required.',
    reserveDescription3:
      'Smaller balls and shorter lanes mean quicker games and more excitement! Duckpin bowling is serving up strikes and spares with menu items and drinks available to order right to your lane.',
    partySizeDescription: 'Duckpin lanes can hold up to 6 people.',
    rental: 'Duckpin Lane Rental',
    rentalDescription1:
      'Experience the thrill of every roll, the rush of every strike, and the buzz of every spare — ' +
      'on state-of-the art duckpin lanes.',
    rentalDescription2: 'Out of this world food and beverage available for purchase.',
    rentalDescription3: '',
    rentalDescription4: '',
    rentalDescription5: '',
    signInDescription:
      'Detroit Duckpin is associated with Five Iron Golf. ' +
      'Enter the email address associated with your Five Iron Golf account to verify your account and complete your booking.',
    createAccountDescription: "Don't have a Five Iron Golf account?",
    offPeakRate: 'Lane Rental Rate',
    errorBox: `Duckpin Lane Rentals can only be booked {{ days }} days in advance, please select another date.`,
    errorBoxSmallEvent: `Small event rentals can only be booked {{ days }} days in advance. Please select another date or choose another party size.`,
    errorBoxLargeEvent: `For large events (13+), please contact the location directly.`,
    lessonType: 'Session Length',
  },
  [Variants.FIVEIRON]: {
    reserve: 'Book a Simulator',
    book_lesson: 'Book a Lesson',
    book_club_fitting: 'Club Fitting',
    book_lane: 'Book a Lane',
    simulators: 'Simulators',
    clubFittingDescription1:
      "Elevate your equipment with a personalized session guided by Five Iron's expert fitters. " +
      "Using Trackman technology and Callaway's premium equipment, our team will analyze your performance to recommend the perfect clubs to optimize your game.",
    reserveDescription1: 'Prices range depending on the location and time of day.',
    reserveDescription2:
      'Choose between use of the driving range, course play, or games and competition, all for the same price.',
    reserveDescription3: 'Enjoy a curated menu of food and beverage items available for order.',
    partySizeDescription:
      'Individual simulators can fit up to 6. For larger groups, please contact the location or book multiple appointments.',
    rental: 'Simulator Rental',
    rentalDescription1:
      'Complimentary Use of Premium Callaway Golf Clubs — Including lefty, kids’, or women’s sets.',
    rentalDescription2: '450+ World-Famous Courses — Pebble Beach to St. Andrews.',
    rentalDescription3:
      'Games for All Ages — Scrapyard, Capture-the-Flag, Streets of Neon, Magic Pond.',
    rentalDescription4:
      'Drinks, Craft Cocktails, and A Delicious Food Menu — For purchase, delivered to your bay.',
    rentalDescription5: 'Golf Coaches — Available to swing by for a quick tip.',
    signInDescription:
      'Enter the email address associated with your Five Iron Golf account to verify your account and complete your booking.',
    createAccountDescription: 'New to Five Iron?',
    offPeakRate: 'Off Peak Rate',
    errorBox: `Simulator Rentals can only be booked {{ days }} days in advance, please select another date.`,
    errorBoxSmallEvent: `Small event rentals can only be booked {{ days }} days in advance. Please select another date or choose another party size.`,
    errorBoxLargeEvent: `For large events (13+), please contact the location directly.`,
    lessonType: 'Lesson Type',
  },
  [Variants.FIVEIRON_MOBILE]: {},
} as { [key in Variants]: { [key: string]: string } };

export const genericDuckpinOverrides: { [key: string]: string } = {
  reserveDescription1: 'Book by the hour for up to 6 bowlers per lane.',
  reserveDescription3:
    "We're serving up strikes and spares with menu items and drinks available to order right to your lane.",
  partySizeDescription: 'Lanes can hold up to 6 people.',
  rental: 'Lane Rental',
  rentalDescription1:
    'Experience the thrill of every roll, the rush of every strike, and the buzz of every spare — ' +
    'on state-of-the art bowling lanes.',
  signInDescription:
    'Enter the email address associated with your Five Iron Golf account to verify your account and complete your booking.',
  createAccountDescription: 'New to Five Iron?',
  errorBox: `Lane Rentals can only be booked {{ days }} days in advance, please select another date.`,
};

export const coralGablesOverrides: { [key: string]: string } = {
  reserveDescription1: 'Book by the hour for up to 5 bowlers per lane.',
  reserveDescription2: 'Let the good times roll!',
  partySizeDescription: 'Lanes can hold up to 5 people.',
};

export const resolveDuckpinCopy = (code: string, isGeneric: boolean, isCoralGables: boolean): string => {
  const base = config[Variants.DUCKPIN][code];
  const generic = isGeneric ? genericDuckpinOverrides[code] ?? base : base;
  return isCoralGables ? coralGablesOverrides[code] ?? generic : generic;
};

export default config;
